import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    Label,
    Input,
    Spinner,
    Table
} from "reactstrap"
import api from "helpers/Api"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as productAction from "../../../store/cHJvZHVjdERldGFpb/actions"
import ButtonSpinner from "../../../components/ButtonSpinner"
import { toast } from "react-toastify"
import Select from "react-select"


const ProductDetailReport = (props) => {
    const { dispatch, searchBtnStyle } = props
    const title = "Product Details Report"

    //Search bar and validations   
    const specificDispatch = useDispatch()

    useEffect(() => {
        specificDispatch(productAction.loadRecordsMetaData())
        dispatch(
            productAction.loadProduct({
                page: 1,
                limit: 50,
            })
        )
    }, [])

    const ticketUpdate = useSelector((state) => state.productDetailReport)

    const { recordsMetaData = {}, product_details = [] } = ticketUpdate


    const sessionUpdate = useSelector((specificstate) => specificstate.session)

    const { user = [] } = sessionUpdate

    const [pageCount, setPageCount] = useState(false)
    const [pageChange, setPageChange] = useState(false)
    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState([])

    const [downloadLoading, setDownloadLoading] = useState(false)

    //Date format
    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []

    const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

    //dropdown initial state  
    const [productName, setProductName] = useState([])
    const [productCategoryName, setProductCategoryName] = useState([])
    const [deliverableStatus, setDeliverableStatus] = useState([])
    const [ewName, setEwName] = useState([])
    const [printStatus, setPrintStatus] = useState([])
    const [crmName, setCrmName] = useState([])


    const [historyModal, setHistoryModal] = useState(false)
    const [history_details, setHistoryDetails] = useState([])
    const [processStatusModal, setProcessStatusModal] = useState(false)
    const [processHistoryDetails, setProcessHistoryDetails] = useState("")
    const [agentKey, setAgentKey] = useState(false)
    //RESET FILTER
    const resetForm = () => {
        setEwName([])
        setPrintStatus([])
        setDeliverableStatus([])
        setProductName([])
        setProductCategoryName([])
        setSearchInput("")

        setAgentKey(true)
        setTimeout(() => {
            setAgentKey(false)
        }, 0)

        setCrmName([])
        dispatch(
            productAction.loadProduct({
                page: 1,
                limit: 50,
            })
        )
    }

    const fuseAgentOptions = {
        keys: ["empCode", "label"],
    }
    //button spinner state
    const [btnLoader, setBtnLoader] = useState(false)
    const [followupStatusModal, setFollowupStatusModal] = useState(false)
    //Apply filter submit
    const productCategoryValue = !isEmpty(productCategoryName) ?
        productCategoryName.map(m => m.value) : ""

    const productNameValue = !isEmpty(productName) ?
        productName.map(m => m.value) : ""

    const deliverableStatusValue = !isEmpty(deliverableStatus) ?
        deliverableStatus.map(m => m.value) : ""

    const printStatusValue = !isEmpty(printStatus) ?
        printStatus.map(m => m.value) : ""
    const applyFilter = (e) => {
        e.preventDefault()



        var searchCrm = !isEmpty(crmName)
            ? crmName.value
            : ""
        var searchProductCategory = !isEmpty(productCategoryName)
            ? productCategoryValue
            : ""

        var searchProductName = !isEmpty(productName)
            ? productNameValue
            : ""

        var searchDeliverableStatus = !isEmpty(deliverableStatus)
            ? deliverableStatusValue
            : ""

        var searchEwName = !isEmpty(ewName)
            ? ewName.value
            : ""

        var searchPrintStatus = !isEmpty(printStatus)
            ? printStatusValue
            : ""

        var searchValue = {}
        searchValue.page = pageChange ? pageCount : 1
        searchValue.limit = sizePerPage ? sizePerPage : 50


        if (searchCrm) {
            searchValue.crmId = searchCrm
        }
        if (searchProductCategory) {
            searchValue.productCategoryId = searchProductCategory
        }
        if (searchProductName) {
            searchValue.productId = searchProductName
        }
        if (searchDeliverableStatus) {
            searchValue.deliverableStatus = searchDeliverableStatus
        }
        if (searchPrintStatus) {
            searchValue.printStatus = searchPrintStatus
        }

        if (searchEwName) {
            searchValue.EW_Id = searchEwName
        }

        specificDispatch(productAction.loadProduct(searchValue))
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 2000)
    }
    const [operationHistoryDetails, setOperationHistoryDetails] = useState("")
    const [deliverableModal, setDeliverableModal] = useState(false)
    //clientDetailsReportTable
    const clientDetailsReportTable =
        !isEmpty(product_details) &&
            product_details.data &&
            product_details.data.length > 0
            ? product_details.data.map((data, index) => {

                const applicableEventNameValue = data && data.applicableEvents && !isEmpty(data.applicableEvents) ?
                    data.applicableEvents.filter((m) => m.eventName !== null && m.eventName !== undefined)
                        .map(m => m.eventName).join(",") : "--"

                const plEmpData = data && data.plEmpData && !isEmpty(data.plEmpData) ?
                    data.plEmpData.map(m => m.name).join(",") : "--"
                const ewData = data && data.EWEmpData && !isEmpty(data.EWEmpData) ?
                    data.EWEmpData.map(m => m.name).join(",") : "--"
                const colorCode =
                    !isEmpty(recordsMetaData) &&
                    recordsMetaData.deliverableStatusOptions &&
                    recordsMetaData.deliverableStatusOptions.length > 0 &&
                    recordsMetaData.deliverableStatusOptions.find(
                        (_) => _.processStatusId === data.deliverableStatus || _.label === data.deliverableStatusName
                    ) &&
                    recordsMetaData.deliverableStatusOptions.find(
                        (_) => _.processStatusId === data.deliverableStatus || _.label === data.deliverableStatusName
                    ).colorCode
                const printColorCode =
                    !isEmpty(recordsMetaData) &&
                    recordsMetaData.deliverableStatusOptions &&
                    recordsMetaData.deliverableStatusOptions.length > 0 &&
                    recordsMetaData.deliverableStatusOptions.find(
                        (_) => _.processStatusId === data.printStatus || _.label === data.printStatusName
                    ) &&
                    recordsMetaData.deliverableStatusOptions.find(
                        (_) => _.processStatusId === data.printStatus || _.label === data.printStatusName
                    ).colorCode
                return {
                    _id: data._id,
                    sNo: index + 1,
                    productCategory: data.productCategoryName || "--",
                    productName: data.productName || "--",
                    leadNo: data.leadNo || "--",
                    clientName: data.clientName || "--",
                    brideName: data.brideName || "--",
                    groomName: data.groomName || "--",
                    applicableEventName: applicableEventNameValue,
                    crmName: data.postCrmAssignedName || "--",
                    deliverableStatus: data.deliverableStatus,
                    deliverableStatusName: data.deliverableStatusName,
                    printDeliverableCode: data.printdeliverableCode || "--",
                    printStatus: data.printStatus,
                    printStatusName: data.printStatusName,
                    processStatusHistory: !isEmpty(data.processHistory) ? data.processHistory : [],
                    assignHistory: !isEmpty(data.assignedHistory) ? data.assignedHistory : [],
                    lastUpdatedDate: data.lastUpdatedOn ? moment(data.lastUpdatedOn).format(dateFormate) : "--",
                    plName: plEmpData,
                    ewName: ewData,
                    salesAgentName: data.SalesAgentName || "--",
                    deliverableHistory: !isEmpty(data.deliverableHistory) ? data.deliverableHistory : [],
                    deliverableId: "",
                    lastEditedBy: data.lastEditedByName || "--",
                    lastEditedDate: data.lastEditedDate ? moment
                        .utc(data.lastEditedDate)
                        .format(`${dateFormate} ${"hh:mm A"}`) : "--",
                    etaDate: data.ETA ? moment(data.ETA).format(dateFormate) : "--",
                    leadStatus: data.leadStatus,
                    operationStatus: data.operationStatus,
                    dataCopyStatus: data.dataCopyStatus,
                    dataCopyDate: data.dataCopiedOn ? moment(data.dataCopiedOn).format(dateFormate) : "--",
                    subStatus: data.subStatus,
                    ECStatus: data.ECStatus,
                    colorCode: colorCode,
                    printColorCode: printColorCode,
                    printPlName:data.assignPlEmpData?data.assignPlEmpData.map(m=>`${m.empCode}-${m.name}`).join(",") : "--",
                    printAssignDate:data.assignPlDate?moment(data.assignPlDate).format(dateFormate):"--",
                    additionalProductRemarks:data.additionalProductRemarks || "--",

                }
            })
            : []

    //columns for data table
    const initialColumns = [
        {
            dataField: "sNo",
            text: "S.No",
            hidden: false,
            // expandRow: false,
        },

        {
            dataField: "productCategory",
            text: "Product Category",
            hidden: false,
            headerStyle: {
                minWidth: "145px",
            },
        },
        {
            dataField: "productName",
            text: "Product Name",
            headerStyle: {
                minWidth: "150px",
            },
            hidden: false,
        },
        {
            dataField: "leadNo",
            text: "Lead No",
            hidden: false,
            style: {
                color: "#e40d8c",
                textTransform: "uppercase",
            },
            headerStyle: {
                minWidth: "145px",
            },
        },
        {
            dataField: "clientName",
            text: "Client Name",
            hidden: false,
            headerStyle: {
                minWidth: "145px",
            },
        },
        {
            dataField: "brideName",
            text: "Bride Name",
            hidden: false,
            headerStyle: {
                minWidth: "140px",
            },
        },
        {
            dataField: "groomName",
            text: "Groom Name",
            hidden: false,
            headerStyle: {
                minWidth: "140px",
            },
        },


        {
            dataField: "applicableEventName",
            text: "Applicable Event Name",
            hidden: false,
            headerStyle: {
                minWidth: "185px",
            },
        },
        {
            dataField: "crmName",
            text: "CRM Name",
            hidden: false,
            headerStyle: {
                minWidth: "140px",
            },
        },
        {
            dataField: "deliverableStatusName",
            text: "Deliverable Status",
            hidden: false,
            headerStyle: {
                minWidth: "160px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div>
                        {!isEmpty(row.deliverableStatusName) ? (
                            <button
                                style={{
                                    background: row.colorCode,
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                }}
                            >
                                {row.deliverableStatusName}
                            </button>
                        ) : (
                            "--"
                        )}
                    </div>
                )
            },
        },
        {
            dataField: "printDeliverableCode",
            text: "Print Deliverable Code",
            hidden: false,
            headerStyle: {
                minWidth: "180px",
            },

        },
        {
            dataField: "printStatus",
            text: "Print Status",
            hidden: false,
            headerStyle: {
                minWidth: "140px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div>
                        {!isEmpty(row.printStatusName) ? (
                            <button
                                style={{
                                    background: row.printColorCode,
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                }}
                            >
                                {row.printStatusName}
                            </button>
                        ) : (
                            "--"
                        )}
                    </div>
                )
            },
        },

        {
            dataField: "processStatusHistory",
            text: "Process Status History",
            hidden: false,
            headerStyle: {
                minWidth: "180px",
            },
            formatter: (cellContent, row) => {
                return (
                    <Row>
                        <Col md="6" lg="6" sm="6">
                            {row.processStatusHistory ? <div className="space-between">
                                <span className="badge rounded-pill bg-primary">
                                    {row.processStatusHistory.length}
                                </span>
                            </div> : "--"}

                        </Col>
                        <Col md="4" lg="4" sm="4">
                            <i
                                className="fas fa-eye text-info fs-5"
                                onClick={() => {
                                    setProcessHistoryDetails(row.processStatusHistory)
                                    setProcessStatusModal(true)
                                }}
                            ></i>
                        </Col>
                    </Row>

                )
            },
        },
        {
            dataField: "assignHistory",
            text: "Assign History",
            hidden: false,
            headerStyle: {
                minWidth: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <Row>
                        <Col md="6" lg="6" sm="6">
                            {row.assignHistory ? <div className="space-between">
                                <span className="badge rounded-pill bg-primary">
                                    {row.assignHistory.length}
                                </span>
                            </div> : "--"}

                        </Col>
                        <Col md="4" lg="4" sm="4">
                            <i
                                className="fas fa-eye text-info fs-5"
                                onClick={() => {
                                    setHistoryDetails(row.assignHistory)
                                    setHistoryModal(true)
                                }}
                            ></i>
                        </Col>
                    </Row>

                )
            },
        },
        {
            dataField: "lastUpdatedDate",
            text: "Last Updated Date",
            hidden: false,
            headerStyle: {
                minWidth: "175px",
            },
        },
        {
            dataField: "plName",
            text: "PL Name",
            hidden: false,
            headerStyle: {
                minWidth: "145px",
            },
        },
        {
            dataField: "ewName",
            text: "EW Name",
            hidden: false,
            headerStyle: {
                minWidth: "145px",
            },
        },

        {
            dataField: "salesAgentName",
            text: "Sales Agent Name",
            hidden: false,
            headerStyle: {
                minWidth: "155px",
            },
        },
        {
            dataField: "deliverableHistory",
            text: "Deliverable History",
            hidden: false,
            headerStyle: {
                minWidth: "160px",
            },
            formatter: (cellContent, row) => {
                return (
                    <Row>
                        <Col md="6" lg="6" sm="6">
                            {row.deliverableHistory ? <div className="space-between">
                                <span className="badge rounded-pill bg-primary">
                                    {row.deliverableHistory.length}
                                </span>
                            </div> : "--"}

                        </Col>
                        <Col md="4" lg="4" sm="4">
                            <i
                                className="fas fa-eye text-info fs-5"
                                onClick={() => {
                                    setOperationHistoryDetails(row.deliverableHistory)
                                    setDeliverableModal(true)
                                }}
                            ></i>
                        </Col>
                    </Row>

                )
            },
        },
        {
            dataField: "printPlName",
            text: "Print PL Name",
            hidden: false,
            headerStyle: {
                minWidth: "146px",
            },
        },
        {
            dataField: "printAssignDate",
            text: "Print Assign Date",
            hidden: false,
            headerStyle: {
                minWidth: "156px",
            },
        },
        {
            dataField: "additinalProductRemarks",
            text: "Additional Product Remarks",
            hidden: false,
            headerStyle: {
                
                minWidth: "196px",
            },
        },
        {
            dataField: "lastEditedBy",
            text: "Last Edited By",
            hidden: false,
            headerStyle: {
                minWidth: "136px",
            },
        },
        {
            dataField: "lastEditedDate",
            text: "Last Edited Date and Time",
            hidden: false,
            headerStyle: {
                minWidth: "216px",
            },
        },
        {
            dataField: "etaDate",
            text: "ETA Date",
            hidden: false,
            headerStyle: {
                minWidth: "225px",
            },
        },
        {
            dataField: "leadStatus",
            text: "Lead Status",
            hidden: true,
            headerStyle: {
                minWidth: "225px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div>
                        {!isEmpty(row.leadStatus) ? (
                            <button
                                style={{
                                    background: cellContent == "COMPLETED" ? "#28a745" : "#dc3545",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                }}
                            >
                                {row.leadStatus}
                            </button>
                        ) : (
                            "--"
                        )}
                    </div>
                )
            },
        },
        {
            dataField: "ECStatus",
            text: "EC Status",
            hidden: true,
            headerStyle: {
                minWidth: "225px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div>
                        {!isEmpty(row.ECStatus) ? (
                            <button
                                style={{
                                    background: cellContent == "COMPLETED" ? "#28a745" : "#dc3545",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                }}
                            >
                                {row.ECStatus}
                            </button>
                        ) : (
                            "--"
                        )}
                    </div>
                )
            },
        },
        {
            dataField: "operationStatus",
            text: "Operation Status",
            hidden: true,
            headerStyle: {
                minWidth: "225px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div>
                        {!isEmpty(row.operationStatus) ? (
                            <button
                                style={{
                                    background: cellContent == "COMPLETED" ? "#28a745" : "#dc3545",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                }}
                            >
                                {row.operationStatus}
                            </button>
                        ) : (
                            "--"
                        )}
                    </div>
                )
            },
        },
        {
            dataField: "dataCopyStatus",
            text: "Data Copy Status",
            hidden: true,
            headerStyle: {
                minWidth: "225px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div>
                        {!isEmpty(row.dataCopyStatus) ? (
                            <button
                                style={{
                                    background: cellContent == "COMPLETED" ? "#28a745" : "#dc3545",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                }}
                            >
                                {row.dataCopyStatus}
                            </button>
                        ) : (
                            "--"
                        )}
                    </div>
                )
            },
        },
        {
            dataField: "dataCopyDate",
            text: "Data Copy Date",
            hidden: true,
            headerStyle: {
                minWidth: "225px",
            },
        },
        {
            dataField: "subStatus",
            text: "Sub Status",
            hidden: false,
            headerStyle: {
                minWidth: "225px",
            },
            formatter: (cellContent, row) => {

                return (
                    <div>
                        {!isEmpty(row.subStatus) ? (
                            <button
                                style={{
                                    background: cellContent == "COMPLETED" ? "#28a745" : "#dc3545",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                }}
                            >
                                {row.subStatus}
                            </button>
                        ) : (
                            "--"
                        )}
                    </div>
                )
            },
        },
    ]
    //Columns section
    const [columns, setColumns] = useState(initialColumns)
    const [columnModal, setColumnModal] = useState(false)
    const [oddColumnData, setOddColumnData] = useState([])
    const [evenColumnData, setEvenColumnData] = useState([])
    useEffect(() => {
        if (columns && columns.length > 0) {
            var array = columns
            var evenColumns = []
            var oddColumns = []

            for (var i = 0; i < array.length; i++) {
                if (i % 2 === 0) {
                    oddColumns.push(array[i])
                } else {
                    evenColumns.push(array[i])
                }
            }

            setOddColumnData(oddColumns)
            setEvenColumnData(evenColumns)
        }
    }, [columns])

    const selectColumn = columns
        .filter((column) => column.hidden === false)
        .map((column) => column.dataField)

    const [selectedColumns, setSelectedColumns] = useState(selectColumn)

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target

        let updatedSelectedColumns
        if (checked) {
            updatedSelectedColumns = [...selectedColumns, value]
        } else {
            updatedSelectedColumns = selectedColumns.filter(
                (column) => column !== value
            )
        }

        setSelectedColumns(updatedSelectedColumns)
    }

    //  "Select All" checkbox
    const handleSelectAllChange = (e) => {
        const { checked } = e.target
        if (checked) {
            const allColumns = columns.map((column) => column.dataField)
            setSelectedColumns(allColumns)
        } else {
            const restoredColumns = initialColumns
                .filter((column) => !column.hidden)
                .map((column) => column.dataField)
            setSelectedColumns(restoredColumns)
        }
    }

    const handleSaveColumns = () => {
        setColumnModal(false)

        const updatedColumns = columns.map((column) => {
            const isColumnSelected = selectedColumns.includes(column.dataField)
            return { ...column, hidden: !isColumnSelected }
        })

        setColumns(updatedColumns)
        // default columns
        const defaultColumns = initialColumns.filter((column) => !column.hidden)
        const selectedNonDefaultColumns = selectedColumns.filter(
            (column) =>
                !defaultColumns.some(
                    (defaultColumn) => defaultColumn.dataField === column
                )
        )

        if (selectedNonDefaultColumns.length > 0) {
            toast.success("New Columns added successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
            })
        }
    }

    const handleRestoreToDefault = () => {
        const restoreColumns = initialColumns
            .filter((column) => !column.hidden)
            .map((column) => column.dataField)

        setSelectedColumns(restoreColumns)
    }

    const [loading, setLoading] = useState(false)

    //Search filter

    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)

        dispatch(
            productAction.loadProduct({
                searchFilter: searchInput,
                page: pageChange ? pageCount : 1,
                limit: 50,
            })
        )
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportToCsv = () => {




        var searchCrm = !isEmpty(crmName)
            ? crmName.value
            : ""
        var searchProductCategory = !isEmpty(productCategoryName)
            ? productCategoryValue
            : ""

        var searchProductName = !isEmpty(productName)
            ? productNameValue
            : ""

        var searchDeliverableStatus = !isEmpty(deliverableStatus)
            ? deliverableStatusValue
            : ""

        var searchEwName = !isEmpty(ewName)
            ? ewName.value
            : ""

        var searchPrintStatus = !isEmpty(printStatus)
            ? printStatusValue
            : ""

        var searchValue = {}

        if (searchCrm) {
            searchValue.crmId = searchCrm
        }
        if (searchProductCategory) {
            searchValue.productCategoryId = searchProductCategory
        }
        if (searchProductName) {
            searchValue.productId = searchProductName
        }
        if (searchDeliverableStatus) {
            searchValue.deliverableStatus = searchDeliverableStatus
        }
        if (searchPrintStatus) {
            searchValue.printStatus = searchPrintStatus
        }

        if (searchEwName) {
            searchValue.EW_Id = searchEwName
        }

        setPageLoad(!pageLoad)

        setDownloadLoading(true)
        api
            .post(`/production_details_report_export_excel`, searchValue)
            .then((response) => {
                const exportDataTable = !isEmpty(response.data.data)
                    ? response.data.data.map((data, index) => {

                        const applicableEventName = data && data.applicableEvents && !isEmpty(data.applicableEvents) ?
                            data.applicableEvents.filter((m) => m.eventName !== null && m.eventName !== undefined)
                                .map(m => m.eventName).join(",") : "--"
                        const applicableEventNameValue = !isEmpty(applicableEventName)
                            ? JSON.stringify(applicableEventName).replace(/","/g, "\n")
                            : "--"

                        const plEmpData = data && data.plEmpData && !isEmpty(data.plEmpData) ?
                            data.plEmpData.map(m => m.name).join(",") : "--"
                        const plEmpDataValue = !isEmpty(plEmpData)
                            ? JSON.stringify(plEmpData).replace(/","/g, "\n")
                            : "--"

                        const ewData = data && data.EWEmpData && !isEmpty(data.EWEmpData) ?
                            data.EWEmpData.map(m => m.name).join(",") : "--"
                        const ewDataValue = !isEmpty(ewData)
                            ? JSON.stringify(ewData).replace(/","/g, "\n")
                            : "--"
                        const addRemarks = !isEmpty(data.additionalProductRemarks)
                        ? JSON.stringify(data.additionalProductRemarks).replace(/","/g, "\n")
                        : "--"
                        const printName = data.assignPlEmpData?
                        data.assignPlEmpData.map(m=>`${m.empCode}-${m.name}`).join(",") : ""
                        const printNameValue = !isEmpty(printName)
                        ? JSON.stringify(printName).replace(/","/g, "\n")
                        : "--"
                        return {
                            _id: data._id,
                            sNo: index + 1,
                            productCategory: data.productCategoryName || "--",
                            productName: data.productName || "--",
                            leadNo: data.leadNo || "--",
                            clientName: data.clientName || "--",
                            brideName: data.brideName || "--",
                            groomName: data.groomName || "--",
                            applicableEventName: applicableEventNameValue,
                            crmName: data.postCrmAssignedName || "--",
                            deliverableStatus: data.deliverableStatus,
                            deliverableStatusName: data.deliverableStatusName,
                            printDeliverableCode: data.printdeliverableCode || "--",
                            printStatus: data.printStatus|| "--",
                            printStatusName: data.printStatusName,
                            processStatusHistory: !isEmpty(data.processHistory) ? data.processHistory.length : 0,
                            assignHistory: !isEmpty(data.assignedHistory) ? data.assignedHistory.length : 0,
                            lastUpdatedDate: data.lastUpdatedOn ? moment(data.lastUpdatedOn).format(dateFormate) : "--",
                            plName: plEmpDataValue,
                            ewName: ewDataValue,
                            salesAgentName: data.SalesAgentName || "--",
                            deliverableHistory: !isEmpty(data.deliverableHistory) ? data.deliverableHistory.length : 0,

                            lastEditedBy: data.lastEditedByName || "--",
                            lastEditedDate: data.lastEditedDate ? moment
                                .utc(data.lastEditedDate)
                                .format(`${dateFormate} ${"hh:mm A"}`) : "--",
                            etaDate: data.ETA ? moment(data.ETA).format(dateFormate) : "--",
                            leadStatus: data.leadStatus || "--",
                            operationStatus: data.operationStatus || "--",
                            dataCopyStatus: data.dataCopyStatus || "--",
                            dataCopyDate: data.dataCopiedOn ? moment(data.dataCopiedOn).format(dateFormate) : "--",
                            subStatus: data.subStatus || "--",
                            ECStatus: data.ECStatus || "--",
                            printPlName:printNameValue || "--",
                            printAssignDate:data.assignPlDate?moment(data.assignPlDate).format(dateFormate):"--",
                            additionalProductRemarks: addRemarks || "--",
                        }
                    })
                    : []
                setTimeout(() => {
                    let headerData = [
                        "SNo,Product Category,Product Name,Lead No,Client Name,Bride Name,Groom Name,Applicable Events Name,CRM Name,Deliverable Status,Print Deliverable Code,Print Status,Process Status History,Assign History,Last Updated Date,PL Name,EW Name,Sales Agent Name,Deliverable History,Print Pl Name,Print Assign Date,Additional Product Remarks,Last Edited By,Last Edited Date and Time,ETA Date,Lead Status,EC Status,Operation Status,Data Copy Status,Data Copy Date,Sub Status,",
                    ]

                    let usersCsv =
                        !isEmpty(exportDataTable) &&
                        exportDataTable.reduce((acc, user) => {
                            const {
                                sNo,
                                productCategory,
                                productName,
                                leadNo,
                                clientName,
                                brideName,
                                groomName,
                                applicableEventName,
                                crmName,
                                deliverableStatusName,
                                printDeliverableCode,
                                printStatusName,
                                processStatusHistory,
                                assignHistory,
                                lastUpdatedDate,
                                plName,
                                ewName,
                                salesAgentName,
                                deliverableHistory,
                                printPlName,
                                printAssignDate,
                                additionalProductRemarks,
                                lastEditedBy,
                                lastEditedDate,
                                etaDate,
                                leadStatus,
                                ECStatus,
                                operationStatus,
                                dataCopyStatus,
                                dataCopyDate,
                                subStatus

                            } = user
                            acc.push([
                                sNo,
                                productCategory,
                                productName,
                                leadNo,
                                clientName,
                                brideName,
                                groomName,
                                applicableEventName,
                                crmName,
                                deliverableStatusName,
                                printDeliverableCode,
                                printStatusName,
                                processStatusHistory,
                                assignHistory,
                                lastUpdatedDate,
                                plName,
                                ewName,
                                salesAgentName,
                                deliverableHistory,
                                printPlName,
                                printAssignDate,
                                additionalProductRemarks,
                                lastEditedBy,
                                lastEditedDate,
                                etaDate,
                                leadStatus,
                                ECStatus,
                                operationStatus,
                                dataCopyStatus,
                                dataCopyDate,
                                subStatus
                            ])


                            return acc
                        }, [])

                    downloadFile({
                        data: [...headerData, ...usersCsv].join("\n"),
                        fileName: "ProductDetailReport.csv",
                        fileType: "text/csv",
                    })
                    setDownloadLoading(false)
                }, 2500)
                return response.data
            })
            .catch((error) => {
                setDownloadLoading(false)
                Promise.reject(error)
            })
    }
    const RemotePagination = ({
        data,
        page,
        // sort,
        sizePerPage,
        onTableChange,
        totalSize,
    }) => (
        <div>
            <PaginationProvider
                pagination={paginationFactory({
                    custom: true,
                    page,
                    // sort,
                    sizePerPage,
                    totalSize,
                })}
            >
                {({ paginationProps, paginationTableProps }) => (
                    <div>
                        <ToolkitProvider
                            keyField="_id"
                            data={data}
                            columns={columns}
                            search
                            exportCSV
                        >
                            {() => (
                                <div>
                                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                        <Row className="d-flex flex-row">
                                            <Col className="mb-3" md="4"></Col>
                                            <Col
                                                md="8"
                                                style={{ marginBottom: "20px", marginTop: "-41px" }}
                                            >
                                                <div
                                                    style={{
                                                        float: "right",
                                                    }}
                                                >
                                                    <Button
                                                        className="btn btn-info"
                                                        onClick={() => setColumnModal(true)}
                                                    >
                                                        Edit Columns
                                                    </Button>
                                                </div>
                                                <div
                                                    style={{
                                                        float: "right",
                                                        marginRight: "10px",
                                                    }}
                                                >
                                                    <Button
                                                        className="btn btn-primary"
                                                        onClick={exportToCsv}
                                                        id="download"
                                                        style={{
                                                            backgroundColor: "#e40d8c",
                                                            color: "white",
                                                            border: "none",
                                                        }}
                                                    >
                                                        Download
                                                    </Button>
                                                </div>
                                            </Col>

                                            <Col>
                                                <BootstrapTable
                                                    remote
                                                    keyField="_id"
                                                    data={data}
                                                    id="ImportTable"
                                                    columns={columns}
                                                    noDataIndication={"No Data Found..."}
                                                    responsive
                                                    striped={true}
                                                    bordered={true}
                                                    onTableChange={onTableChange}
                                                    {...paginationTableProps}
                                                />
                                            </Col>
                                        </Row>
                                        <Row
                                            style={{ marginTop: "5px" }}
                                            className="align-items-md-center mt-30"
                                        >
                                            <Col className="inner-custom-pagination d-flex">
                                                <div className="d-inline d-flex flex-row">
                                                    <SizePerPageDropdownStandalone {...paginationProps} />
                                                    <div
                                                        style={{
                                                            fontSize: "14px",
                                                            marginTop: "8px",
                                                            marginLeft: "4px",
                                                        }}
                                                    >
                                                        <PaginationTotalStandalone {...paginationProps} />
                                                    </div>
                                                </div>
                                                <div
                                                    className="text-md-right ms-auto"
                                                    style={{ zIndex: 0 }}
                                                >
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>
                            )}
                        </ToolkitProvider>
                    </div>
                )}
            </PaginationProvider>
        </div>
    )
    const [pageLoad, setPageLoad] = useState(false)
    const [state, setState] = useState({
        sizePerPage: 50,
        page: 1,
        totalSize: product_details.length,
        data:
            !isEmpty(product_details) && product_details.length > 0
                ? product_details.slice(0, 50)
                : [],
    })
    const { sizePerPage, page } = state

    //Table Change

    const handleTableChange = (
        type,
        { page, sortField, sortOrder, currentIndex, sizePerPage }
    ) => {
        setPageCount(page)
        setPageChange(true)
        setPageLoad(!pageLoad)
        let result =
            !isEmpty(product_details) && product_details.length > 0
                ? product_details
                : []
        if (

            !isEmpty(crmName) ||
            !isEmpty(ewName) ||
            !isEmpty(productCategoryName) ||
            !isEmpty(deliverableStatus) ||
            !isEmpty(printStatus) ||
            !isEmpty(productName)
        ) {

            var searchCrm = !isEmpty(crmName)
                ? crmName.value
                : ""
            var searchProductCategory = !isEmpty(productCategoryName)
                ? productCategoryValue
                : ""

            var searchProductName = !isEmpty(productName)
                ? productNameValue
                : ""

            var searchDeliverableStatus = !isEmpty(deliverableStatus)
                ? deliverableStatusValue
                : ""

            var searchEwName = !isEmpty(ewName)
                ? ewName.value
                : ""

            var searchPrintStatus = !isEmpty(printStatus)
                ? printStatusValue
                : ""

            var searchValue = {}
            searchValue.page = page
            searchValue.limit = sizePerPage ? sizePerPage : 50

            if (searchCrm) {
                searchValue.crmId = searchCrm
            }
            if (searchProductCategory) {
                searchValue.productCategoryId = searchProductCategory
            }
            if (searchProductName) {
                searchValue.productId = searchProductName
            }
            if (searchDeliverableStatus) {
                searchValue.deliverableStatus = searchDeliverableStatus
            }
            if (searchPrintStatus) {
                searchValue.printStatus = searchPrintStatus
            }

            if (searchEwName) {
                searchValue.EW_Id = searchEwName
            }

            setPageLoad(!pageLoad)
            setLoading(true)
            specificDispatch(productAction.loadProduct(searchValue))
        } else {
            dispatch(
                productAction.loadProduct({
                    page: page,
                    limit: sizePerPage,
                })
            )
            setLoading(true)
            setPageLoad(!pageLoad)
        }
        // setPageCount(page)
        setTimeout(() => {
            setLoading(false)
        }, 2000)
        if (sortOrder === "asc") {
            result = result.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return 1
                } else if (b[sortField] > a[sortField]) {
                    return -1
                }
                return 0
            })
        } else {
            result = result.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return -1
                } else if (b[sortField] > a[sortField]) {
                    return 1
                }
                return 0
            })
        }

        setState(() => ({
            page,
            data: result.slice(currentIndex, currentIndex + sizePerPage),
            totalSize: result.length,
            sizePerPage,
        }))
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{title} | Zero Gravity CRM</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title={"Operations"} breadcrumbItem={title} />

                    {/*form start */}
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <form>
                                        <Row>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"}>
                                                        {"Product Name"}
                                                    </Label>
                                                </div>
                                                <Select
                                                    type="text"
                                                    isMulti
                                                    name="productName"
                                                    value={productName}
                                                    onChange={(e) => setProductName(e)}
                                                    options={
                                                        recordsMetaData
                                                            ? recordsMetaData.productOptions
                                                            : []
                                                    }
                                                    placeholder="Select Product Name"
                                                    classNamePrefix="select2-selection" 
                                                    styles={{
                                                        menu: (provided) => ({
                                                          ...provided,
                                                          zIndex:100, // Set your desired zIndex value
                                                        }),
                                                      }}
                                                />

                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"}>
                                                        {"Product Category"}
                                                    </Label>
                                                </div>
                                                <Select
                                                    type="text"
                                                    isMulti
                                                    name="productCategoryName"
                                                    value={productCategoryName}
                                                    onChange={(e) => setProductCategoryName(e)}
                                                    options={
                                                        recordsMetaData
                                                            ? recordsMetaData.productCategoryOptions
                                                            : []
                                                    }
                                                    placeholder="Select Product Category"
                                                    classNamePrefix="select2-selection"
                                                />

                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"}>
                                                        {"Deliverable Status"}
                                                    </Label>
                                                </div>
                                                <Select
                                                    type="text"
                                                    isMulti
                                                    name="deliverableStatus"
                                                    value={deliverableStatus}
                                                    onChange={(e) => setDeliverableStatus(e)}
                                                    options={
                                                        recordsMetaData
                                                            ? recordsMetaData.deliverableStatusOptions
                                                            : []
                                                    }
                                                    placeholder="Select Deliverable Status"
                                                    classNamePrefix="select2-selection"
                                                />

                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className="form-label" htmlFor={"CRM Name"}>
                                                        {"CRM Name"}
                                                    </Label>
                                                </div>
                                                <ReactSearchAutocomplete
                                                    name="crmName"
                                                    key={agentKey}
                                                    items={recordsMetaData.employeeOptions}
                                                    value={crmName}
                                                    type="autoComplete"
                                                    resultStringKeyName="label"
                                                    showIcon={false}
                                                    onSelect={(e) => setCrmName(e)}
                                                    onChange={(e) => setCrmName(e.target.value)}
                                                    onClear={() => setCrmName([])}
                                                    placeholder="Enter CRM Name"
                                                    fuseOptions={fuseAgentOptions} // Search on both fields
                                                    styling={{
                                                        height: "34px",
                                                        border: "1px solid #ced4da",
                                                        borderRadius: "4px",
                                                        backgroundColor: "white",
                                                        boxShadow: "none",
                                                        hoverBackgroundColor: "#E40D8C",
                                                        color: "black",
                                                        fontSize: "12px",
                                                        fontFamily: "Courier",
                                                        iconColor: "green",
                                                        clearIconMargin: "3px 8px 0 0",
                                                        zIndex: 10,
                                                    }}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className="form-label" htmlFor={"CRM Name"}>
                                                        {"EW Name"}
                                                    </Label>
                                                </div>
                                                <ReactSearchAutocomplete
                                                    name="ewName"
                                                    key={agentKey}
                                                    items={recordsMetaData.employeeOptions}
                                                    value={ewName}
                                                    type="autoComplete"
                                                    resultStringKeyName="label"
                                                    showIcon={false}
                                                    onSelect={(e) => setEwName(e)}
                                                    onChange={(e) => setEwName(e.target.value)}
                                                    onClear={() => setEwName([])}
                                                    placeholder="Enter EW Name"
                                                    fuseOptions={fuseAgentOptions} // Search on both fields
                                                    styling={{
                                                        height: "34px",
                                                        border: "1px solid #ced4da",
                                                        borderRadius: "4px",
                                                        backgroundColor: "white",
                                                        boxShadow: "none",
                                                        hoverBackgroundColor: "#E40D8C",
                                                        color: "black",
                                                        fontSize: "12px",
                                                        fontFamily: "Courier",
                                                        iconColor: "green",
                                                        clearIconMargin: "3px 8px 0 0",
                                                        zIndex: 10,
                                                    }}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"}>
                                                        {"Print Status"}
                                                    </Label>
                                                </div>
                                                <Select
                                                    type="text"
                                                    isMulti
                                                    name="printStatus"
                                                    value={printStatus}
                                                    onChange={(e) => setPrintStatus(e)}
                                                    options={
                                                        recordsMetaData
                                                            ? recordsMetaData.deliverableStatusOptions
                                                            : []
                                                    }
                                                    placeholder="Select Print Status"
                                                    classNamePrefix="select2-selection"
                                                />

                                            </Col>

                                        </Row>
                                        <Row>
                                            <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                                                <div
                                                    className="filter-buttons"
                                                    style={{ float: "right" }}
                                                >
                                                    <Button
                                                        type="button"
                                                        onClick={() => resetForm()}
                                                        className="btn btn-danger btn-label simple-form-Reset-btn"
                                                    >
                                                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                        Reset
                                                    </Button>
                                                    <Button
                                                        type="submit"
                                                        onClick={(e) => applyFilter(e)}
                                                        className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                                                    >
                                                        <i className="bx bx-filter-alt label-icon"></i>
                                                        {btnLoader && btnLoader ? (
                                                            <ButtonSpinner />
                                                        ) : (
                                                            "Apply Filter"
                                                        )}{" "}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="12" xl="12">
                            <Card>
                                <CardBody>
                                    <div
                                        className="d-flex flex-row"
                                        style={{ marginTop: "20px" }}
                                    >
                                        <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                            <form onSubmit={handleClick} className="d-flex flex-row">
                                                <div style={searchBtnStyle || null}>
                                                    <Input
                                                        type="text"
                                                        name="searchInput"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        className="form-control"
                                                        placeholder="Search"
                                                        style={{ position: "relative" }}
                                                    />
                                                    <i
                                                        className="bx bx-search-alt"
                                                        style={{
                                                            position: "absolute",
                                                            top: "54px",
                                                            left: "41px",
                                                            fontSize: "13px",
                                                        }}
                                                    />
                                                </div>
                                                <button
                                                    className="btn btn-success mx-2"
                                                    type="submit"
                                                    style={{
                                                        background: searchFilter ? "#2ca67a" : "",
                                                        color: searchFilter ? "#ffffff" : "",
                                                    }}
                                                >
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </form>
                                        </div>
                                    </div>{" "}
                                    <RemotePagination
                                        data={clientDetailsReportTable}
                                        page={page}
                                        sizePerPage={sizePerPage}
                                        totalSize={
                                            product_details.totalDataCount
                                                ? product_details.totalDataCount
                                                : 0
                                        }
                                        onTableChange={handleTableChange}
                                    />
                                    {loading ? (
                                        <Modal
                                            show={loading}
                                            style={{ width: "7%", margin: "18% 50%" }}
                                        >
                                            <Modal.Body>
                                                <Spinner
                                                    as="span"
                                                    animation="grow"
                                                    size="lg"
                                                    role="status"
                                                    aria-hidden="true"
                                                    variant="success"
                                                    className="mx-2"
                                                    color="success"
                                                />
                                            </Modal.Body>
                                        </Modal>
                                    ) : (
                                        ""
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {columnModal && (
                        <Modal size="xl" show={columnModal}>
                            <Modal.Header
                                style={{
                                    backgroundColor: "white",
                                    color: "black",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                }}
                            >
                                Edit Columns
                                <span>
                                    <i
                                        className="fa fa-times quote-close"
                                        aria-hidden="true"
                                        onClick={() => setColumnModal(false)}
                                    ></i>
                                </span>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <div>
                                        <Input
                                            type="checkbox"
                                            checked={selectedColumns.length === columns.length}
                                            onChange={(e) => handleSelectAllChange(e)}
                                            style={{ width: "15px", height: "15px" }}
                                        />
                                        <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                                            Select All
                                        </Label>
                                    </div>
                                </Row>
                                <Row>
                                    <Col sm="12" md="6" lg="6" className="ml-4">
                                        {oddColumnData.map((column) => (
                                            <div key={column.dataField} className="d-flex flex-row">
                                                <div className="form-check form-check-inline">
                                                    <Input
                                                        type="checkbox"
                                                        value={column.dataField}
                                                        checked={selectedColumns.includes(column.dataField)}
                                                        onChange={(e) => handleCheckboxChange(e)}
                                                        style={{ width: "15px", height: "15px" }}
                                                    />
                                                    <Label
                                                        style={{
                                                            fontSize: "16px",
                                                            marginLeft: "10px",
                                                        }}
                                                    >
                                                        {column.text}
                                                    </Label>
                                                </div>
                                            </div>
                                        ))}
                                    </Col>
                                    <Col sm="12" md="6" lg="6">
                                        {evenColumnData.map((column) => (
                                            <div key={column.dataField} className="d-flex flex-row">
                                                <div className="form-check form-check-inline">
                                                    <Input
                                                        type="checkbox"
                                                        value={column.dataField}
                                                        checked={selectedColumns.includes(column.dataField)}
                                                        onChange={(e) => handleCheckboxChange(e)}
                                                        style={{ width: "15px", height: "15px" }}
                                                    />
                                                    <Label
                                                        style={{
                                                            fontSize: "16px",
                                                            marginLeft: "10px",
                                                        }}
                                                    >
                                                        {column.text}
                                                    </Label>
                                                </div>
                                            </div>
                                        ))}
                                    </Col>
                                </Row>
                            </Modal.Body>

                            <Modal.Footer>
                                <p
                                    className="text-decoration-underline text-info"
                                    style={{ cursor: "pointer", fontSize: "16px" }}
                                    onClick={handleRestoreToDefault}
                                >
                                    Restore To Default
                                </p>
                                <Button
                                    variant="secondary"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                        setColumnModal(false)
                                        setSelectedColumns(selectColumn)
                                    }}
                                >
                                    Close
                                </Button>
                                <Button
                                    variant="primary"
                                    className="btn btn-success"
                                    onClick={() => handleSaveColumns()}
                                >
                                    Submit
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                    {downloadLoading ? (
                        <Modal
                            show={downloadLoading}
                            style={{ width: "7%", margin: "18% 50%" }}
                        >
                            <Modal.Body>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="lg"
                                    role="status"
                                    aria-hidden="true"
                                    variant="success"
                                    className="mx-2"
                                    color="success"
                                />
                            </Modal.Body>
                        </Modal>
                    ) : (
                        ""
                    )}
                    {followupStatusModal && (
                        <Modal size="md" show={followupStatusModal}>
                            <Modal.Header
                                style={{
                                    backgroundColor: "#E40D8C",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                }}
                            >
                                Confirm
                            </Modal.Header>
                            <Modal.Body>
                                Are You Sure Do You Want To Close Followup Status?
                            </Modal.Body>

                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={() => setFollowupStatusModal(false)}
                                >
                                    No
                                </Button>
                                <Button
                                    variant="secondary"
                                    className="btn btn-success"
                                    data-bs-dismiss="modal"
                                    onClick={() => setFollowupStatusModal(false)}
                                >
                                    Yes
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                    {processStatusModal && (
                        <Modal size="xl" show={processStatusModal}>
                            <Modal.Header
                                style={{
                                    backgroundColor: "#E40D8C",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                }}
                            >
                                Deliverable History
                            </Modal.Header>
                            <Modal.Body>


                                <Row>
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Mode</th>
                                                <th>Employee Name</th>
                                                <th>Deliverable Status</th>
                                                <th>Notes</th>
                                                <th>Attachment</th>
                                                <th>Created By</th>
                                                <th>Created On</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!isEmpty(processHistoryDetails) &&
                                                processHistoryDetails.length > 0 ? (
                                                processHistoryDetails.map((data, index) => {
                                                    const createdOn = !isEmpty(data.createdOn)
                                                        ? moment(data.createdOn)
                                                            .subtract(5, "hours")
                                                            .subtract(30, "minutes")
                                                            .format(`${dateFormate} ${"hh:mm A"}`)
                                                        : "--"
                                                    const empName =
                                                        data.employeeName && data.employeeCode
                                                            ? data.employeeCode +
                                                            "-" +
                                                            data.employeeName
                                                            : "--"
                                                    const attachment = !isEmpty(data.attachment)
                                                        ? data.attachment.map((m) => m).join()
                                                        : ""
                                                    const attachExtension = !isEmpty(attachment)
                                                        ? attachment.split(".").pop()
                                                        : ""
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{data.mode ? data.mode : "--"}</td>
                                                            <td>{empName}</td>
                                                            <td>
                                                                {data.productioProcessStatusName
                                                                    ? data.productioProcessStatusName
                                                                    : "--"}
                                                            </td>
                                                            <td>{data.notes ? data.notes : "--"}</td>
                                                            <td>
                                                                {" "}
                                                                {(attachment &&
                                                                    attachExtension === "jpeg") ||
                                                                    (attachment &&
                                                                        attachExtension === "jpg") ||
                                                                    (attachment &&
                                                                        attachExtension === "png") ? (
                                                                    <a
                                                                        onClick={() =>
                                                                            window.open(attachment, "_blank")
                                                                        }
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                textDecoration: "underline",
                                                                                color: "#E40D8C",
                                                                            }}
                                                                        >
                                                                            View
                                                                        </span>
                                                                    </a>
                                                                ) : (attachment &&
                                                                    attachExtension === "mp3") ||
                                                                    (attachment &&
                                                                        attachExtension === "m4a") ||
                                                                    (attachment &&
                                                                        attachExtension === "mp4") ? (
                                                                    <a href={attachment}>
                                                                        <audio controls>
                                                                            <source
                                                                                src={attachment}
                                                                                type="audio/mpeg"
                                                                            />
                                                                            Your browser does not support the
                                                                            audio element.
                                                                        </audio>
                                                                    </a>
                                                                ) : (
                                                                    "--"
                                                                )}
                                                            </td>
                                                            <td>
                                                                {data.createdByName
                                                                    ? data.createdByName
                                                                    : "--"}
                                                            </td>
                                                            <td>{createdOn}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td className="text-align-center" colSpan={8}>
                                                        No Records Found...
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Row>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={() => setProcessStatusModal(false)}
                                >
                                    Close
                                </Button>

                            </Modal.Footer>
                        </Modal>
                    )}       {historyModal && (
                        <Modal size="xl" show={historyModal}>
                            <Modal.Header
                                style={{
                                    backgroundColor: "#E40D8C",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                }}
                            >
                                Assigned History
                            </Modal.Header>
                            <Modal.Body>
                                <Row className="mt-3">
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Type</th>
                                                <th>Employee Name</th>
                                                <th>Notes</th>
                                                <th>Attachment</th>
                                                <th>Created On</th>
                                                <th>Created By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!isEmpty(history_details) &&
                                                history_details.length > 0 ? (
                                                history_details.map((data, index) => {
                                                    const employeeName = !isEmpty(data.empName) ?
                                                        data.empName
                                                            .map((employee) => employee)
                                                            .join()
                                                        : "--"

                                                    const typeName = data.type
                                                        ? data.type
                                                        : "--"

                                                    const notesName = data.notes ? data.notes
                                                        : "--"
                                                    const createdOn = data.createdOn
                                                        ? moment
                                                            .utc(data.createdOn)
                                                            .format(`${dateFormate} ${"hh:mm A"}`) : "--"
                                                    const createdBy = data.createdByName ? data.createdByName
                                                        : "--"
                                                    const attachment =
                                                        data.attachments ? data.attachments : ""


                                                    const attachmentValue = !isEmpty(attachment)
                                                        ? attachment[0]
                                                        : []
                                                    const splitAttach = !isEmpty(attachmentValue)
                                                        ? attachmentValue.split(".")
                                                        : ""
                                                    const attachExtension = !isEmpty(splitAttach)
                                                        ? splitAttach.pop()
                                                        : ""


                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{typeName}</td>
                                                            <td>{employeeName}</td>
                                                            <td>{notesName}</td>
                                                            <td>
                                                                {" "}
                                                                {(attachmentValue &&
                                                                    attachExtension === "jpeg") ||
                                                                    (attachmentValue &&
                                                                        attachExtension === "jpg") ||
                                                                    (attachmentValue &&
                                                                        attachExtension === "png") ? (
                                                                    <div className="d-flex flex-row align-items-center">
                                                                        <a
                                                                            onClick={() =>
                                                                                window.open(
                                                                                    attachmentValue,
                                                                                    "_blank"
                                                                                )
                                                                            }
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    textDecoration: "underline",
                                                                                    color: "#E40D8C",
                                                                                }}
                                                                            >
                                                                                View
                                                                            </span>
                                                                        </a>
                                                                        <div className="ms-auto ml-2">
                                                                            <a
                                                                                style={{
                                                                                    color: "#17b77d",
                                                                                }}
                                                                                //onClick={() => downloadAttachment(attachmentValue, attachmentValue, attachExtension)}
                                                                                // onClick={() => handleDownload()}
                                                                                onClick={() =>
                                                                                    window.open(
                                                                                        attachmentValue,
                                                                                        "_blank"
                                                                                    )

                                                                                }
                                                                            >

                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                ) : (attachmentValue &&
                                                                    attachExtension === "mp3") ||
                                                                    (attachmentValue &&
                                                                        attachExtension === "m4a") ||
                                                                    (attachmentValue &&
                                                                        attachExtension === "mp4") ? (
                                                                    <a href={attachmentValue}>
                                                                        <audio controls>
                                                                            <source
                                                                                src={attachmentValue}
                                                                                type="audio/mpeg"
                                                                            />
                                                                            Your browser does not support the
                                                                            audio element.
                                                                        </audio>
                                                                    </a>
                                                                ) : (
                                                                    "--"
                                                                )}
                                                            </td>

                                                            <td>{createdOn}</td>
                                                            <td>{createdBy}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr key={0}>
                                                    <td className="text-align-center" colSpan={7}>
                                                        No Records Found...
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Row>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={() => setHistoryModal(false)}
                                >
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                    {deliverableModal && (
                        <Modal size="xl" show={deliverableModal}>
                            <Modal.Header
                                style={{
                                    backgroundColor: "#E40D8C",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                }}
                            >
                                Deliverable History
                            </Modal.Header>
                            <Modal.Body>
                                <Row className="mt-3">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Mode</th>
                                                <th>Link</th>
                                                <th>Remarks</th>
                                                <th>Attachment</th>
                                                <th>Quantity</th>
                                                <th>Created By</th>
                                                <th>Created On</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!isEmpty(operationHistoryDetails) &&
                                                operationHistoryDetails.length > 0 ? (
                                                operationHistoryDetails.map((data, index) => {

                                                    const attachment = !isEmpty(data.attachment)
                                                        ? data.attachment.map((m) => m).join()
                                                        : ""

                                                    const attachExtension = !isEmpty(attachment)
                                                        ? attachment.split(".").pop()
                                                        : ""
                                                    const createdOn = !isEmpty(data.createdOn)
                                                        ? moment(data.createdOn)
                                                            .subtract(5, "hours")
                                                            .subtract(30, "minutes")
                                                            .format(`${dateFormate} ${"hh:mm A"}`)
                                                        : "--"
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{data.mode ? data.mode : "--"}</td>

                                                            <td>{data.link ? data.link : "--"}</td>
                                                            <td>{data.remarks ? data.remarks : "--"}</td>
                                                            <td>
                                                                {" "}
                                                                {(attachment && attachExtension === "jpeg") ||
                                                                    (attachment && attachExtension === "jpg") ||
                                                                    (attachment && attachExtension === "png") ? (
                                                                    <a
                                                                        onClick={() =>
                                                                            window.open(attachment, "_blank")
                                                                        }
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                textDecoration: "underline",
                                                                                color: "#E40D8C",
                                                                            }}
                                                                        >
                                                                            View
                                                                        </span>
                                                                    </a>
                                                                ) : (attachment && attachExtension === "mp3") ||
                                                                    (attachment && attachExtension === "m4a") ||
                                                                    (attachment && attachExtension === "mp4") ? (
                                                                    <a href={attachment}>
                                                                        <audio controls>
                                                                            <source
                                                                                src={attachment}
                                                                                type="audio/mpeg"
                                                                            />
                                                                            Your browser does not support the audio
                                                                            element.
                                                                        </audio>
                                                                    </a>
                                                                ) : (
                                                                    "--"
                                                                )}
                                                            </td>
                                                            <td>{data.quantity ? data.quantity : "--"}</td>
                                                            <td>
                                                                {data.createdByName ? data.createdByName : "--"}
                                                            </td>
                                                            <td>{createdOn}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td className="text-align-center" colSpan={9}>
                                                        No Records Found...
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={() => setDeliverableModal(false)}
                                >
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

ProductDetailReport.propTypes = {
    dispatch: PropTypes.func,
    searchProps: PropTypes.func,
    baseProps: PropTypes.any,
    searchBarStyle: PropTypes.any,
    csvProps: PropTypes.any,
    searchBtnStyle: PropTypes.any,
    disableMultiSelect: PropTypes.any,
    title: PropTypes.any,
    onSearch: PropTypes.func,
    onExport: PropTypes.func,
    pageClick: PropTypes.any,
    data: PropTypes.array.isRequired,
    page: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    totalSize: PropTypes.number.isRequired,
    sizePerPage: PropTypes.number.isRequired,
    onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    //mapstate to props
})
//ProductDetailReport
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ProductDetailReport)
)
